import { defineMessages } from 'react-intl';

const scope = 'dashboard.new-contacts';

const messages = defineMessages({
  contactAddDialogHeading: {
    id: `${scope}.ContactAddDialog.Heading`,
    defaultMessage: '연락처 개별 추가',
  },
  contactAddDialogLegendStudent: {
    id: `${scope}.ContactAddDialog.Legend.student`,
    defaultMessage: '학생',
  },
  contactAddDialogGroupFieldLabel: {
    id: `${scope}.ContactAddDialog.GroupField.label`,
    defaultMessage: '그룹명*',
  },
  contactAddDialogTextFieldStudentName: {
    id: `${scope}.ContactAddDialog.TextField.studentName`,
    defaultMessage: '이름*',
  },
  contactAddDialogTextFieldClazzNumber: {
    id: `${scope}.ContactAddDialog.TextField.clazzNumber`,
    defaultMessage: '학급 번호',
  },
  contactAddDialogTextFieldStudentPhoneNumber: {
    id: `${scope}.ContactAddDialog.TextField.studentPhoneNumber`,
    defaultMessage: '휴대폰 번호',
  },
  contactAddDialogTextFieldStudentEmail: {
    id: `${scope}.ContactAddDialog.TextField.stduentEmail`,
    defaultMessage: '이메일 주소',
  },
  contactAddDialogNotePrimaryGuardian: {
    id: `${scope}.ContactAddDialog.Note.primaryGuardian`,
    defaultMessage: '가정통신문은 대표 보호자에게 전송됩니다.',
  },
  contactAddDialogLegendPrimaryGuardian: {
    id: `${scope}.ContactAddDialog.Legend.primaryGuardian`,
    defaultMessage: '대표 보호자',
  },
  contactAddDialogTextFieldPrimaryGuardianName: {
    id: `${scope}.ContactAddDialog.TextField.primaryGuardianName`,
    defaultMessage: '이름*',
  },
  contactAddDialogTextFieldPrimaryGuardianRelationship: {
    id: `${scope}.ContactAddDialog.TextField.primaryGuardianRelationship`,
    defaultMessage: '관계',
  },
  contactAddDialogTextFieldPrimaryGuardianPhoneNumber: {
    id: `${scope}.ContactAddDialog.TextField.primaryGuardianPhoneNumber`,
    defaultMessage: '휴대폰 번호*',
  },
  contactAddDialogTextFieldPrimaryGuardianEmail: {
    id: `${scope}.ContactAddDialog.TextField.primaryGuardianEmail`,
    defaultMessage: '이메일 주소',
  },
  contactAddDialogDeleteButton: {
    id: `${scope}.ContactAddDialog.DeleteButton`,
    defaultMessage: '삭제',
  },
  contactAddDialogLegendSecondaryGuardian: {
    id: `${scope}.ContactAddDialog.Legend.secondaryGuardian`,
    defaultMessage: '보조 보호자',
  },
  contactAddDialogTextFieldSecondaryGuardianName: {
    id: `${scope}.ContactAddDialog.TextField.secondaryGuardianName`,
    defaultMessage: '이름*',
  },
  contactAddDialogTextFieldSecondaryGuardianRelationship: {
    id: `${scope}.ContactAddDialog.TextField.secondaryGuardianRelationship`,
    defaultMessage: '관계',
  },
  contactAddDialogTextFieldSecondaryGuardianPhoneNumber: {
    id: `${scope}.ContactAddDialog.TextField.secondaryGuardianPhoneNumber`,
    defaultMessage: '휴대폰 번호*',
  },
  contactAddDialogTextFieldSecondaryGuardianEmail: {
    id: `${scope}.ContactAddDialog.TextField.secondaryGuardianEmail`,
    defaultMessage: '이메일 주소',
  },
  contactAddDialogAddButton: {
    id: `${scope}.ContactAddDialog.AddButton`,
    defaultMessage: '보호자 추가',
  },
  contactAddDialogContactSwapButton: {
    id: `${scope}.ContactAddDialog.ContactSwapButton`,
    defaultMessage: '대표 보호자 변경',
  },
  contactAddDialogCancelButton: {
    id: `${scope}.ContactAddDialog.CancelButton`,
    defaultMessage: '취소',
  },
  contactAddDialogSaveButton: {
    id: `${scope}.ContactAddDialog.SaveButton`,
    defaultMessage: '저장',
  },
  newContactsButton: {
    id: `${scope}.NewContacts.Button`,
    defaultMessage: '주소록에 추가',
  },
  excelDownloadBoxLink: {
    id: `${scope}.ExcelDownloadBox.Link`,
    defaultMessage: 'Excel 양식 다운로드',
  },
  excelDownloadBoxTextStrong: {
    id: `${scope}.ExcelDownloadBox.text.strong`,
    defaultMessage: '1. 파일 양식 받기',
  },
  excelDownloadBoxTextHelper: {
    id: `${scope}.ExcelDownloadBox.text.helper`,
    defaultMessage: '추가할 연락처를 양식에 맞추어 작성해주세요.',
  },
  excelUploadBoxExcelClearButton: {
    id: `${scope}.ExcelUploadBox.ExcelClearButton`,
    defaultMessage: '삭제',
  },
  excelUploadBoxExcelUploadButton: {
    id: `${scope}.ExcelUploadBox.ExcelUploadButton`,
    defaultMessage: '파일 선택',
  },
  excelUploadBoxTextStrong: {
    id: `${scope}.ExcelUploadBox.text.strong`,
    defaultMessage: '2. 파일 첨부하기',
  },
  excelUploadBoxTextHelper: {
    id: `${scope}.ExcelUploadBox.text.helper`,
    defaultMessage: 'csv, xls, xlsx 파일을 첨부해주세요.',
  },
  newContactsHeading: {
    id: `${scope}.NewContacts.Heading`,
    defaultMessage: '연락처 추가',
  },
  newContactsSubheading: {
    id: `${scope}.NewContacts.Subheading`,
    defaultMessage: 'Excel 파일로 일괄 불러오기',
  },
  newContactsSmallSubheading: {
    id: `${scope}.NewContacts.SmallSubheading`,
    defaultMessage: '불러온 연락처 { count }건',
  },
  newContactsContactCounts: {
    id: `${scope}.NewContacts.ContactCounts`,
    defaultMessage: '(신규 { new }건/ 중복 { duplicated }건)',
  },
  newContactsNotice: {
    id: `${scope}.NewContacts.Notice`,
    defaultMessage: '중복 연락처 포함',
  },
  newContactsContactAddButton: {
    id: `${scope}.NewContacts.ContactAddButton`,
    defaultMessage: '개별 추가',
  },
  newContactTableHeadType: {
    id: `${scope}.NewContactTable.head.type`,
    defaultMessage: '구분',
  },
  newContactTableHeadGroup: {
    id: `${scope}.NewContactTable.head.group`,
    defaultMessage: '그룹명',
  },
  newContactTableHeadNumber: {
    id: `${scope}.NewContactTable.head.clazzNumber`,
    defaultMessage: '번호',
  },
  newContactTableHeadStudentName: {
    id: `${scope}.NewContactTable.head.studentName`,
    defaultMessage: '학생 이름*',
  },
  newContactTableHeadStudentPhoneNumber: {
    id: `${scope}.NewContactTable.head.studentPhoneNumber`,
    defaultMessage: '학생 휴대폰 번호',
  },
  newContactTableHeadGuardianName: {
    id: `${scope}.NewContactTable.head.guardianName`,
    defaultMessage: '보호자 이름*',
  },
  newContactTableHeadGuardianPhoneNumber: {
    id: `${scope}.NewContactTable.head.guardianPhoneNumber`,
    defaultMessage: '보호자 휴대폰 번호*',
  },
  newContactsTableFallbackMessage: {
    id: `${scope}.NewContacts.TableFallbackMessage`,
    defaultMessage: '불러온 연락처가 없습니다.',
  },
});

export default messages;
